import { AcordosDashboard, FiltroAcordos } from "core/features/acordo/typings";
import axios from "infra/http";
import { useQuery } from "react-query";

function useDashboardAcordos(params?: FiltroAcordos) {
  return useQuery(
    [`/v1/acordo/dashboard`, params?.dataInicio, params?.dataFim],
    async () => {
      const res = await axios.get<AcordosDashboard>(`/v1/acordo/dashboard`, {
        params: params
          ? {
              dataInicio: params?.dataInicio,
              dataFim: params?.dataFim,
            }
          : undefined,
      });

      return res.data;
    }
  );
}

export default useDashboardAcordos;
